<template>
    <div>
        <button
            type="button"
            class="btn is-primary"
            @click="$modal.show('import-land-properties')"
        >
            Ladda upp fastigheter & markägare
        </button>
        <adaptive-form-modal
            name="import-land-properties"
            primary-button-text="Ladda upp"
            primary-button-class="is-primary"
            title="Ladda upp fastigheter & markägare"
            :redirect-to="route('admin.delivery-projects.land-properties.index', [projectId])"
            :action="route('api.delivery-projects.land-properties.import', projectId)"
        >
            <div>
                <div class="mb-xl p-xl bg-neutral-lightest text-sm">
                    <p>Observera att filen behöver ha formatet .xlsx och innehålla korrekta tabellnamn.</p>
                    <a href="/templates/imports/land_properties.xlsx" download>Ladda ned exempelfil.</a>
                </div>

                <input
                    id="file"
                    type="file"
                    name="file"
                    class="hidden"
                    accept=".xlsx"
                    @change="setFile"
                >
                <label class="btn is-primary cursor-pointer" for="file">
                    Välj fil
                </label>

                <span class="ml-md text-sm">
                    <span v-if="file">
                        Fil har valts
                    </span>
                    <span v-else>
                        Ingen fil har valts
                    </span>
                </span>

                <div class="text-xs mt-md">
                    <span>
                        Största tillåtna filstorleken är {{ maxFileSize }}
                    </span>
                </div>
            </div>
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            projectId: {
                type: Number,
                required: true,
            },
        },

        data() {
            return {
                file: null,
            };
        },

        computed: {
            maxFileSize() {
                return (window.App && window.App.maxFileSizeImports) ? window.App.maxFileSizeImports : '-';
            },
        },

        methods: {
            setFile(event) {
                this.file = event.target.value;
            },
        },
    };
</script>
